export const customers = state => state.customers.get('customers').toJS();
export const customerData = state => state.customers.get('customerData').toJS();
